/*
 * @Author: Chao Yang
 * @Date: 2020-05-06 10:42:26
 * @LastEditor: Chao Yang
 * @LastEditTime: 2021-02-24 07:16:47
 */

import { Injectable, Injector, EventEmitter, Output, Type } from '@angular/core';
import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import {
  PortalInjector,
  ComponentPortal,
  ComponentType,
} from '@angular/cdk/portal';
import { AdDialogComponent } from './ad-dialog.component';
import { CONFIG_DATA } from './common/ad-dialog-config-inject-key';
import { AdDialogConfig } from './ad-dialog-config';
import { AConfirmComponent } from './a-confirm/a-confirm.component';
import { intersectArrayList } from '../utils/intersect-array-list';
import { getComponentMeta } from '../utils/get-component-meta';

@Injectable()
export class AdDialogService {
  /**
   *
   */
  _defaultConfig: AdDialogConfig;
  @Output() onClose: EventEmitter<any> = new EventEmitter();


  constructor(private overlay: Overlay, private injector: Injector) {
    this._defaultConfig = {
      title: '',
      width: '500px',
      minWidth: '',
      maxWidth: '',
      height: 'auto',
      minHeight: '',
      maxHeight: '',
      backdropClass: '',
      canClose: true,
      isClickBackdropClose: false,
      confirmNoText: "No",
      confirmOkText: "Yes",
      autoBindProperty: false,
      noVisible: true
    };
  }

  open(
    config?: AdDialogConfig,
    component: ComponentType<any> = AdDialogComponent
  ): OverlayRef {
    document.body.classList.add("ovh");
    let _config;
    if (config) {
      _config = Object.assign({}, this._defaultConfig, config);
    } else {
      _config = this._defaultConfig;
    }
    const overlayRef = this.createOverlayRef(config, component);
    (overlayRef as any).componentRef = overlayRef.attach(this.generatePortal(_config, overlayRef, component));
    if (config.autoBindProperty && _config && _config.data && typeof _config.data === "object") {
      let names = getComponentMeta((overlayRef as any).componentRef.componentType).inputs;
      let instance = (overlayRef as any).componentRef.instance;
      let configNames = Object.getOwnPropertyNames(_config.data);
      let keys = intersectArrayList([names, configNames]);
      keys.forEach(key => {
        instance[key] = _config.data[key];
      })
    }
    return overlayRef;
  }

  confirm(config?: AdDialogConfig) {
    return this.open({ ...config, canClose: false }, AConfirmComponent);
  }

  createOverlayRef(config?: AdDialogConfig, component: ComponentType<any> = AdDialogComponent): OverlayRef {


    const positionStrategy = this.overlay
      .position()
      .global()
      .centerHorizontally()
      .centerVertically();
    if (component != AdDialogComponent && config) {
      const overlayRef = this.overlay.create({
        positionStrategy,
        hasBackdrop: true,
        width: config.width,
        height: config.height,
        maxHeight: config.maxHeight,
        maxWidth: config.maxWidth,
        backdropClass: 'a-dialog-backdrop',
      });

      return overlayRef;
    } else {
      const overlayRef = this.overlay.create({
        positionStrategy,
        hasBackdrop: true,
        backdropClass: 'a-dialog-backdrop',
      });

      return overlayRef;
    }
  }

  createInjector(dataToPass): PortalInjector {
    const injectorTokens = new WeakMap();
    injectorTokens.set(CONFIG_DATA, dataToPass);
    return new PortalInjector(this.injector, injectorTokens);
  }

  generatePortal(
    config: AdDialogConfig,
    overlayRef: OverlayRef,
    component: ComponentType<any>
  ) {
    const filePreviewPortal = new ComponentPortal(
      component,
      null,
      this.createInjector({
        config,
        overlayRef,
        close: this.close.bind(this),
      })
    );

    return filePreviewPortal;
  }

  close(overlayRef: OverlayRef) {
    overlayRef.dispose();
    this.onClose.emit(overlayRef);
    document.body.classList.remove("ovh");
  }
}
